import { IEvaluationTypeService } from "../../service/evaluation/EvaluationTypeService";
import { IEvaluationType } from "../../model/evaluation/EvaluationType";

export default class GetEvaluationTypeRuleGroupsInteractor {
  private evaluationTypeService: IEvaluationTypeService;

  constructor(evaluationTypeService) {
    this.evaluationTypeService = evaluationTypeService;
  }

  async execute(evaluation: IEvaluationType) {
    return this.evaluationTypeService.getRuleGroupsForEvaluationType(
      evaluation
    );
  }
}
